import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminHeader } from '../../../shared/components';
import { RoleProtectedRoute } from '../../../shared/components';
import { useRoles } from '../../../shared/hooks';
import EventList from './EventList';

/**
 * Componente principal de gestión de eventos
 * Mantiene el header de navegación consistente con AdminDashboard
 */
const EventManagement = ({ adminData, onLogout }) => {
  const navigate = useNavigate();
  const { ROLES } = useRoles();

  // Manejar volver al dashboard
  const handleBackToDashboard = () => {
    navigate('/admin');
  };

  return (
    <RoleProtectedRoute requiredRoles={[ROLES.ADMIN, ROLES.USER]}>
      <div className="min-h-screen bg-gray-50">
        {/* Header consistente */}
        <AdminHeader
          adminData={adminData}
          onLogout={onLogout}
          showBackButton={true}
          onBackClick={handleBackToDashboard}
          backButtonText="Volver al Dashboard"
        />

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Contenido principal */}
          <EventList />
        </main>
      </div>
    </RoleProtectedRoute>
  );
};

export default EventManagement;